import Layout from './layout';
import Sider from './Sider';
Layout.Sider = Sider;
export default Layout;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/layout/index.js
// module id = 1492
// module chunks = 0